import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import type { NotificationList } from '@/lib/api/models';
import { unwrap } from '@/lib/api/request';
import { useAuthStore } from '@/lib/auth/store';

const KEY = ['notifications'];

/** The current user's notifications. Polls periodically for the unread badge. */
export function useNotifications() {
  const status = useAuthStore((s) => s.status);
  return useQuery<NotificationList>({
    queryKey: KEY,
    queryFn: () => unwrap(api.GET('/notifications', { params: { query: { limit: 30 } } })),
    enabled: status === 'authenticated',
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      unwrap(api.POST('/notifications/{notification_id}/read', { params: { path: { notification_id: id } } })),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => unwrap(api.POST('/notifications/read-all')),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
